import { Component, Input, OnDestroy } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';
import { ApiProjectService } from 'src/app/modules/project/services/http/api-project.service';
import { ApiSettingsService } from 'src/app/modules/settings/services/http/api-settings.service';
import { SettingsService } from 'src/app/modules/settings/services/settings.service';
import { take } from 'rxjs';
import { User } from 'src/app/core/models/user/user.model';
import { CurrentUserStoreService } from 'src/app/core/services/current-user-store.service';
import { Location } from 'src/app/core/models/project/location.model';
import { MqttProjectService } from 'src/app/core/app-load/mqtt-project.service';
import { HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_ROOM, HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_BATHROOM } from 'src/environments/environment';

@Component({
  selector: 'app-room-modal-hvac',
  templateUrl: './room-modal-hvac.component.html',
  styleUrls: ['./room-modal-hvac.component.scss']
})
export class RoomModalHvacComponent implements OnDestroy {
  @Input() location: Location;
  @Input({required: true}) roomOrCommonArea: 'room' | 'commonArea';

  mainSpaceTitle = '';
  secondarySpaceTitle = '';
  public controllers: Controller[];
  public selectedControllers: Controller[] = []; // only one controller should be selected at a time [0]

  public settings$ = this.settingsService.getRoomModalPropSettings();
  public loadingGroupSettings$ = this.mqttProjectService.loadingEditgroupSettings$;

  public Property = Property;
  public renderNumberInputs = true;
  public logedInUser: User;
  public bathroomHasTemps: boolean;
  public hasProps: boolean;
  public fancoilMode: string;

  HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_ROOM = HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_ROOM;
  HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_BATHROOM = HIDE_ROOM_MODAL_HVAC_TEMP_INFO_FOR_BATHROOM;

  constructor(
    private settingsService: SettingsService,
    private apiProjectService: ApiProjectService,
    private apiSettingsService: ApiSettingsService,
    private currentUserStoreService: CurrentUserStoreService,
    private mqttProjectService: MqttProjectService
    ) {}

    ngOnInit(): void {
      this.mainSpaceTitle = this.roomOrCommonArea !== 'commonArea'?'main_area_guest_room':'main_area_common_area';
      this.secondarySpaceTitle = this.roomOrCommonArea !== 'commonArea'?'secondary_area_guest_room':'secondary_area_common_area';

      this.controllers = this.location.controllers.$values;
      this.selectController(this.controllers[0]);
      this.apiSettingsService.getDefaultPresets().subscribe();
      this.getFancoilMode();
      this.logedInUser = this.currentUserStoreService.getUser()
      this.checkIfBathroomHasTemps();
      this.checkForSettings();
    }

    private checkIfBathroomHasTemps() {
      this.settings$.pipe(take(1)).subscribe((settings) => {
        let allBathroomTempProps: Property[] = [];
        settings.bathroom.forEach((setting) => {
          const props = this.selectedControllers.reduce((allFilteredProps, controller) => {
            const filteredPropsOnController = controller.controllerProperties.$values.filter((prop: Property) => {
              return prop.type >= Number(setting.codeFrom) && prop.type <= Number(setting.codeTo);
            });
            return [...allFilteredProps, ...filteredPropsOnController];
          }, []);
          allBathroomTempProps = [...allBathroomTempProps, ...props];
        });
        this.bathroomHasTemps = allBathroomTempProps.length > 0;
      });
    }

    private checkForSettings(){
      this.settings$.pipe(take(1)).subscribe((settings) => {
        let allRoomTempProps: Property[] = [];
        settings.room.forEach(setting => {
          const props =  this.selectedControllers.reduce((allFilteredProps, controller)=> {
            const filteredPropsOnController = controller.controllerProperties.$values.filter((prop: Property) => {
              return (+prop.type >= Number(setting.codeFrom) && +prop.type <= Number(setting.codeFrom))
            });
            allFilteredProps = [...allFilteredProps, ...filteredPropsOnController]
            return allFilteredProps;
          },[]);
            allRoomTempProps = [...allRoomTempProps, ...props];
        });
        this.hasProps = allRoomTempProps.length > 0;
      });
    }

    private getFancoilMode() {
      const target = this.selectedControllers[0].controllerProperties.$values.find( prop => {
        if ((Property.isHvacRoomControlFancoilOff(prop) && typeof +prop.value === 'number' && prop.value !== '') ||
            (Property.isHvacRoomControlFancoilLow(prop) && typeof +prop.value === 'number' && prop.value !== '') ||
            (Property.isHvacRoomControlFancoilMedium(prop) && typeof +prop.value === 'number' && prop.value !== '') ||
            (Property.isHvacRoomControlFancoilHigh(prop) && typeof +prop.value === 'number' && prop.value !== '') ||
            (Property.isHvacRoomControlFancoilAuto(prop) && typeof +prop.value === 'number' && prop.value !== '')) {
          return true;
        }
      })

      if (target) {
        this.fancoilMode = target.value;
      } else {
        this.fancoilMode = '0'
      }
    }

    public selectController(controller: Controller) {
      this.renderNumberInputs = false;
      this.selectedControllers[0] = controller;
      this.selectedControllers = this.selectedControllers.slice();
      setTimeout(() => { // render is reset to reinit child components and restart ngoinit and ngodestroy of child components
        this.renderNumberInputs = true;
      }, 0);
      this.checkForSettings();
      this.checkIfBathroomHasTemps();
    }

    public onFancoilSelect(event: any) {
      let property: Property;
      const parentController: Controller = this.controllers.find(
        (controller: Controller) => {
          property = controller.controllerProperties.$values.find(Property.isHvacRoomControlFancoilOff);
          return property;
        }
      );
      const designation = parentController.designation;
      const propertyId = property.id;
      this.apiProjectService
        .changeProperty(designation, propertyId, event.target.value)
        .subscribe();
    }

    public syncHvacSettings() {
      this.apiProjectService.syncHvacSettings(this.selectedControllers[0].id).subscribe()
    }

    ngOnDestroy(){}
}
